export default class {
    getWidth (average, numberOfTicks) {
        if (!average || !numberOfTicks) {
            return 0;
        }
        // we get average with 1 decimal point
        average = parseFloat(Math.round(average * 10) / 10);
        const width = (100 / numberOfTicks) / 2 + (100 / numberOfTicks) * (average - 1);
        return `${width}%`;
    }
}



// WEBPACK FOOTER //
// ./src/app/services/evaluation/report/index.js